<template>
	<section class="small-12 large-5 columns sisuLeft flex justify-center animated fadeIn">
		<div class="small-12 large-10 logo">
			<picture class="small-12 float-left">
				<router-link :to="{ name: 'SiteIndex' }">
					<img :src="logo" width="100" alt="Nestd Logo" class="animated fadeIn">
				</router-link>
			</picture>
			<div class="small-12 tagLine">
				<h2>Grow your real estate portfolio on your terms.</h2>
			</div>
		</div>
	</section>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'SisuLeft',

		/*
		**  Set up the data
		*/

		data: () => ({

			logo: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/logos%2Fnestd-logo-full-white.png?alt=media&token=e7ba92f7-660f-4454-9fe3-45ab224f6669'

		}),

	}

</script>